export const EN_DASH = '\u2013'
export const EM_DASH = '\u2014'
export const NBSP = '\u00A0'
export const ELLIPSIS = '\u2026'
export const COPYRIGHT = '\u00A9'
export const BULLET = '\u2022'
export const AMP = '\u0026'
export const LT = '\u003C'
export const LTE = '\u2264'
export const GT = '\u003E'
export const GTE = '\u2265'
export const TIMES = '\u00D7'
export const DEG = '\u00B0'

export const APP_URL:string = import.meta.env.VITE_APP_URL ?
    import.meta.env.VITE_APP_URL :
    'https://app.hvaclogsystem.com'

export const APP_SIGNUP_URL = `${APP_URL}/signup`
export const APP_LOGIN_URL = `${APP_URL}/login`
export const APP_HOME_URL = APP_URL
